import React from 'react';
import { params, string, number, useDataModel } from '@thd-nucleus/data-sources';

export const QuestionsAnswersLoader = ({ itemId, children }) => {
  const { data, loading, error } = useDataModel('questionsAnswers', { variables: { itemId } });

  return children({
    data,
    loading,
    error
  });
};

QuestionsAnswersLoader.dataModel = {
  questionsAnswers: params({ itemId: string().isRequired() }).shape({
    TotalResults: number()
  })
};
